import {viewerQueryFactory} from '../../../../../../api/viewer/queryFactory';
import {createQueryClient} from '../../../../../../reactQuery/createQueryClient';

export const fetchViewerEnd = async ({
  seriesId,
  productId,
  apiPath,
}: {
  seriesId: number;
  productId: number;
  apiPath?: string;
}) => {
  const queryClient = createQueryClient();
  const data = await queryClient.fetchQuery(
    viewerQueryFactory.viewerEnd({seriesId, productId, apiPath})
  );
  const viewerEnd = data;
  // 앱에 뷰어엔드 원본데이터를 넘겨줍니다.
  if (window.KPApp && viewerEnd?.originalRawDataStr) {
    window.KPApp?.setViewerEndResponse(viewerEnd.originalRawDataStr);
  }
  return viewerEnd;
};
